module.exports = __webpack_public_path__ + "img/gold-logo.872ec3db.png";